import * as React from 'react'

const DEFAULT_TICK_COLOR = '#3A3F48'

export type BottomTimeFlagProps = {
  left: number
  chartWidth: number
  inner: 'left' | 'right'
  tickColor?: string
  children: React.ReactNode
}

export const BottomTimeFlag: React.FC<BottomTimeFlagProps> = ({
  left,
  chartWidth,
  inner,
  tickColor = DEFAULT_TICK_COLOR,
  children,
}) => {
  const boxRef = React.useRef<HTMLDivElement>(null)
  const [flip, setFlip] = React.useState(false)

  React.useLayoutEffect(() => {
    const el = boxRef.current
    if (!el) return

    setFlip(
      inner === 'left'
        ? left - el.offsetWidth < 0
        : left + el.offsetWidth > chartWidth,
    )
  }, [left, chartWidth, inner, children])

  const alignRightEdge = inner === 'left' ? !flip : flip

  return (
    <div
      className="tw-flex tw-flex-col tw-items-start tw-justify-end"
      style={{
        position: 'absolute',
        left,
        top: 0,
        bottom: 0,
      }}
    >
      <div
        style={{
          background: tickColor,
          height: 4,
          width: 2,
          bottom: 4,
        }}
      />
      <div
        ref={boxRef}
        style={{ transform: alignRightEdge ? 'translateX(-100%)' : undefined }}
      >
        {children}
      </div>
    </div>
  )
}

BottomTimeFlag.displayName = 'BottomTimeFlag'
